import { Icon } from "@zapier/design-system";
import { Tooltip, Button } from "@zapier/design-system-beta";
import { isTemplateChatbotId } from "@zapier/canvas-state";

import { useEmitUserInteractionEvents } from "../../hooks/useEmitUserInteractionEvents";

type Props = { chatbotId: string };

export function ChatbotLink({ chatbotId }: Props) {
  const { emitEventOnAssetOpen } = useEmitUserInteractionEvents();

  // Don't show link if the chatbot id is a template id
  if (isTemplateChatbotId(chatbotId)) {
    return null;
  }

  const chatbotLink = `/app/chatbots/${chatbotId}`;

  return (
    <Tooltip placement="top" content="Open chatbot">
      <Tooltip.FocusableTrigger>
        <Button
          size="small"
          onPress={async () => {
            emitEventOnAssetOpen({
              asset: "Chatbot",
              location: "node",
            });
            window.open(chatbotLink, "_blank");
          }}
        >
          <Icon name="arrowOffsite" size={20} color="BackgroundDefault" />
          Edit
        </Button>
      </Tooltip.FocusableTrigger>
    </Tooltip>
  );
}
